var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlink = function SvgUnlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 25",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.953 14.621 2.122-2.121a5.01 5.01 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0l-.707.707L12.71 7.55l.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-.243.241-.53.435-.844.57L13.418 12.5l1.414-1.414-.707-.707a4.97 4.97 0 0 0-3.535-1.465c-.235 0-.464.032-.691.066L3.71 2.793 2.297 4.207l18 18 1.414-1.414-5.536-5.536q.417-.276.778-.636m-6.363 3.536a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l1.476-1.475-1.414-1.414L4.933 12.5a5.01 5.01 0 0 0 0 7.071 4.98 4.98 0 0 0 3.535 1.462 4.98 4.98 0 0 0 3.536-1.462l.707-.707-1.414-1.414z"
  })));
};
export default SvgUnlink;